/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {defaultSinistreValue} from '../../../../data/constants/Sinistres/famille';
import {stringToDate} from '../../../../data/factory';
import {IError} from '../../../../data/types/interface/Sinistres/famille';
import {StackParams} from '../../../../data/types/navigation';
import {sinistreService} from '../../../../services/applicatif/sinistre';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import Header from '../../../components/Header/HeaderSinistre';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal/index.web';
import {PageContainer} from '../../../components/PageContainer';
import {Form} from './FormWeb';

type NavigationProps = StackNavigationProp<StackParams, 'FamilleSinistre'>;

const data = {
  ...defaultSinistreValue,
};

export const Famille = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [listAgence, setListAgence] = useState([]);
  const [listContrat, setListContrat] = useState([]);
  const [dataDto, setDataDto] = useState(data);
  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [messageError, setShowMessageError] = useState('');
  const {getAgence, user, utilisateurContrat} = props;
  const [listContratSvg, setListContratSvg] = useState([]);
  const [isRedirection, setIsRedirection] = useState(false);
  const {agenceAro} = props.route && props.route.params;
  const [IdContrat, setIdContrat] = useState('');
  const numeroPolice = user.numeroPolice ? user.numeroPolice : '';

  const updateData = (user: any) => {
    dataDto.nomContractant = `${user.nom} ${user.prenom}`;
    dataDto.nomDeclarant = `${user.nom} ${user.prenom}`;
    dataDto.telephone = user.telephone;
    dataDto.numeroContrat = numeroPolice;
    dataDto.agence = agenceAro ? agenceAro : '';

    if (numeroPolice && numeroPolice !== '') {
      setIsRedirection(true);
    } else {
      setIsRedirection(false);
    }

    return dataDto;
  };

  useEffect(() => {
    if (user && user.data && user.data.utilisateur) {
      const _data = updateData(user.data.utilisateur);
      setDataDto(_data);
    }
  }, [user]);

  useEffect(() => {
    getListContrat();
  }, []);

  const getListContrat = () => {
    setIsLoading(true);
    utilisateurContrat(
      {},
      (res: any) => {
        setIsLoading(false);
        if (res && res.data && res.data.items) {
          setListContratSvg(res.data.items);
          const _data = mapContrat(res.data.items);
          setListContrat(_data);
        } else {
          if (res) {
            if (res.isError) {
              setShowMessageError(res.message);
            }
            setShowError(true);
          }
        }
      },
      `?typeSinistre=family`,
    );
  };

  const mapAgence = (list: any) => {
    list = list.map((e: any) => {
      return {
        value: e.nom,
        label: e.nom,
      };
    });
    return list;
  };

  const mapContrat = (list: any) => {
    list = list.map((e: any) => {
      return {
        value: e.numeroPolice,
        label: e.numeroPolice,
      };
    });
    return list;
  };
  useEffect(() => {
    setIsLoading(true);
    getAgence({}, (res: any) => {
      if (res && !res.isError && res.data && res.data.items) {
        const _list = mapAgence(res.data.items);
        setListAgence(_list);
      }
      setIsLoading(false);
    });
  }, []);

  const handleCancel = () => {
    goBack();
  };

  const handleSubmit = (response: any) => {
    const _photo = [];
    const _pieceJointeAgence = [];
    _pieceJointeAgence.push(response.pieceJointeAgence);
    _photo.push(response.photo);
    const _data = {...response};
    console.log('_data a :', _data);
    _data.dateSinistre = stringToDate(response.dateSinistre);
    setDataDto(_data);
    response = formDataDTO(response);
    setIsLoading(true);
    sinistreService()
      .registerFamille(response)
      .then((res: any) => {
        if (res && !res.isError && res.data) {
          res.data.data.id && setIdContrat(res.data.data.id);
          setPostSuccess(true);
        } else {
          res && setShowMessageError(res.message);
          setShowError(true);
        }
        setIsLoading(false);
      });
  };

  const formDataDTO = (datas: IError) => {
    const formData = new FormData();
    datas.photo.length > 0 &&
      datas.photo.forEach((elt: any) => {
        formData.append('photo', elt);
      });
    datas.pieceJointeAgence.length > 0 &&
      datas.pieceJointeAgence.forEach((elt: any) => {
        formData.append('pieceJointeAgence', elt);
      });
    formData.append('numeroContrat', datas.numeroContrat);
    formData.append('nomDeclarant', datas.nomDeclarant);
    formData.append('agence', datas.agence);
    formData.append('nomContractant', datas.nomContractant);
    formData.append('telephone', datas.telephone);
    formData.append('circonstanceAccident', datas.circonstanceAccident);
    formData.append('dateSinistre', datas.dateSinistre);
    formData.append('lieuSinistre', datas.lieuSinistre);
    formData.append('estimationPrejudice', datas.estimationPrejudice);

    return formData;
  };

  return (
    <View>
      <HeaderScreen
        title="Déclarer un sinistre"
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        {/** Confirmation modal */}
        {postSucces && (
          <ConfirmationModal
            title="Votre demande a été prise en compte"
            content="Nous reviendrons éventuellement vers vous pour des compléments d'information"
            btn1="OK"
            handleBtn1={() => {
              setPostSuccess(false);
              navigate('MonEspace');
            }}
          />
        )}
        {showError && (
          <ConfirmationModal
            title="Erreur"
            content={messageError}
            btn1="OK"
            handleBtn1={() => setShowError(false)}
          />
        )}
        {/** Loading */}
        {IsLoading && <Loader />}
        {/** Header content */}
        {!IsLoading && !postSucces && <Header isFamille={true} />}
        {/** Form content */}
        {!postSucces && !IsLoading && (
          <Form
            data={dataDto}
            isRedirection={isRedirection}
            listAgence={listAgence}
            listContrat={listContrat}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
            listContratSvg={listContratSvg}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const FamilleSinistre: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Famille);
